import { Flex } from "@aircall/tractor";

import { SectionLayoutProps } from ".";

export function SectionLayout({
  children,
  "data-test": dataTest = "section-layout",
}: SectionLayoutProps) {
  return (
    <Flex gap="xs" flexDirection="column" data-test={dataTest}>
      {children}
    </Flex>
  );
}
